/**
 * Backward-compatibility shim around the unified `usePermissionsGate`.
 * Existing consumers (DriverHome, useDeviceStatusBroadcast) only care
 * about the location bit; we re-export the same shape they expected.
 */
import { usePermissionsGate } from '@/hooks/usePermissionsGate';
import type { LocationPermState } from '@/hooks/usePermissionsGate';

export type LocationGateStatus = 'checking' | LocationPermState;

export function useLocationGate(): { status: LocationGateStatus; requestEnableLocation: () => Promise<void> } {
  const { status: gateStatus, perms, request } = usePermissionsGate();
  const status: LocationGateStatus = gateStatus === 'checking' ? 'checking' : perms.location;
  return { status, requestEnableLocation: () => request('location') };
}
